var _defs, _g, _g2, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPiecesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-1,.cls-3{fill-rule:evenodd;}.cls-2{mask:url(#mask);}.cls-4{mask:url(#mask-2-2);}"), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 51.64,
    y: 10.137,
    width: 419.1,
    height: 482.863,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    className: "cls-1",
    points: "51.64 10.137 470.739 10.137 470.739 492.996 51.64 492.996 51.64 10.137"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2-2",
    x: 51.632,
    y: 10.133,
    width: 419.107,
    height: 482.863,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    className: "cls-1",
    points: "51.632 492.996 470.739 492.996 470.739 10.133 51.632 10.133 51.632 492.996"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    className: "cls-3",
    d: "M412.141,280.763a19.517,19.517,0,0,0,2.194,15.222,21.019,21.019,0,0,0,13.174,9.466l9.41,2.2a10.711,10.711,0,0,1,6.88,4.816,8.56,8.56,0,0,1,1.007,6.731L406.2,464.566c-1.4,5.328-7.408,8.5-13.414,7.147l-100.261-23.4h94a12.215,12.215,0,0,0,12.263-12.166V59.655l2.6.131a6.1,6.1,0,0,1,4.267,1.938,4.309,4.309,0,0,1,1.163,3.14L402.947,129.7l46.426,10.845ZM73.216,31.542h304V426.476a1.023,1.023,0,0,1-.468.428H73.216ZM467.869,129.7a20.936,20.936,0,0,0-13.149-9.454l-29.609-6.91,2.805-47.223a25.009,25.009,0,0,0-6.5-18.361A27.158,27.158,0,0,0,402.5,38.844l-3.716-.19V22.29a12.212,12.212,0,0,0-12.263-12.153H63.89A12.2,12.2,0,0,0,51.64,22.29V436.144A12.2,12.2,0,0,0,63.89,448.31H86.115A26.728,26.728,0,0,0,109.25,461.5H256.74L387.927,492.12a33.249,33.249,0,0,0,7.588.88c14.337,0,27.451-9.276,31.119-23.094l38.61-145.356a29.255,29.255,0,0,0-3.32-22.881,31.764,31.764,0,0,0-20.151-14.437l-9.194-1.117,37.5-141.182a19.5,19.5,0,0,0-2.206-15.234Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    className: "cls-3",
    points: "107.169 145.726 240.37 145.726 240.37 131.039 107.169 131.039 107.169 145.726"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    className: "cls-3",
    points: "107.169 185.528 286.976 185.528 286.976 170.842 107.169 170.842 107.169 185.528"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-7",
    className: "cls-3",
    points: "107.169 229.22 179.092 229.22 179.092 214.533 107.169 214.533 107.169 229.22"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPiecesIcon);
export default __webpack_public_path__ + "static/media/PiecesIcon.20e63ebcaae6fea30359983c50005741.svg";
export { ForwardRef as ReactComponent };